import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, ClipboardCheck, FolderOpen, Phone, ArrowRight } from "lucide-react";

const ServicesSection = () => {
  const services = [
    { title: "Apply for Bursary", icon: <GraduationCap size={20} className="text-blue-700 shrink-0" />, link: "/register" },
    { title: "Check Status",      icon: <ClipboardCheck size={20} className="text-blue-700 shrink-0" />, link: "/login" },
    { title: "Requirements",      icon: <FolderOpen size={20} className="text-blue-700 shrink-0" />,     link: "/requirements" },
    { title: "Get Help",          icon: <Phone size={20} className="text-blue-700 shrink-0" />,          link: "/support" },
  ];

  return (
    <section className="py-10 bg-gray-50 border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold mb-6">How can we help you today?</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.map((service) => (
            <Link
              key={service.title}
              to={service.link}
              className="flex items-center gap-3 bg-white px-4 py-3.5 rounded-xl border border-gray-200 hover:bg-blue-50 hover:border-blue-300 hover:shadow-sm transition-all duration-150 group"
            >
              {service.icon}
              <span className="text-sm font-medium text-gray-700 group-hover:text-blue-700 transition-colors">{service.title}</span>
              <ArrowRight size={15} className="ml-auto text-gray-300 group-hover:text-blue-500 group-hover:translate-x-0.5 transition-all" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;